<template>
  <b-input-group>
    <b-form-input v-if="type === 'progress'" v-model="entity.estimated_completition" type="number" @change="save"
      :class="[{ saving }]" :disabled="(!active) || saving || loading"></b-form-input>
    <b-form-datepicker v-else v-model="entity.estimated_end_date" @input="save" :class="[{ saving }]"
      :disabled="(!active) || saving || loading"></b-form-datepicker>
    <b-input-group-append v-if="!active">
      <b-button variant="success" @click="onEditClick"><i class="fa fa-pencil" aria-hidden="true"></i></b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import Services from '@/services';

export default {
  mounted() {
    this.loadData();
  },
  props: {
    jira_key: { // project_id
      type: String,
      requred: true
    },
    type: { // project_id
      type: String,
      default: 'enddate', // progress
      requred: true
    },
  },
  data() {
    return {
      entity: {
        estimated_end_date: null,
        estimated_completition: null,
      },
      saving: false,
      loading: false,
      active: false,
    };
  },
  components: {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onEditClick() {
      this.active = true;
    },
    loadData() {
      this.loading = true;
      Services.jira.getEndDateProgress({ jira_key: this.jira_key }).then(({ data }) => {
        this.entity = data;
        this.loading = false;
      });
    },
    save() {
      this.saving = true;
      Services.jira.setEndDateProgress({
        jira_key: this.jira_key,
        ...((this.type === 'progress') ? { estimated_completition: this.entity.estimated_completition } : { estimated_end_date: this.entity.estimated_end_date })
      }).then(({ data }) => {
        this.entity = data;
        this.saving = false;
      });
    },
  }
};
</script>

<style scoped lang=scss>
.saving {
  border-color: rgb(201, 151, 0);
}
</style>
